import React, { useContext } from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { AppContext } from 'Context';
import logo from 'Assets/Login Logo.png';
import styles from './index.module.css';

export const Logo = ({
  className, isLight, isLarge, footerLogo,
}) => {
  // Co-branding: when the signed-in user has a brand logo, show it ALONGSIDE the
  // Projector wordmark (Projector logo + divider + brand logo), not instead of.
  // brandLogoUrl is a presigned URL provided via AppContext.
  const { brandLogoUrl, brandName } = useContext(AppContext) || {};
  return (
    <div className={cn({
      [styles.logo]: true, [styles.large]: isLarge, [className]: className, [styles.footerLogo]: footerLogo,
    })}
    >
      <Link to="/access" className={cn(styles.logoLink, { [styles.coBrand]: brandLogoUrl })}>
        <img className={styles.logoImage} src={logo} alt="projector logo" />
        {brandLogoUrl && (
          <>
            <span className={styles.coBrandDivider} aria-hidden="true">×</span>
            <img
              className={cn(styles.logoImage, styles.brandLogoImage)}
              src={brandLogoUrl}
              alt={brandName || 'Brand logo'}
            />
          </>
        )}
      </Link>
    </div>
  );
};
